export default __webpack_public_path__ + "static/B0144-73185b626deeabb3530afe1dd35089db.png";